import {useEffect, useState} from 'react';

/**
 * Used as a fallback for useScreenDetector to allow SSG
 * need to change the client code to opt out of this code
 */
export const useScreenDetectorFallback = () => {
  const [width, setWidth] = useState(640);

  useEffect(() => {
    setWidth(window.innerWidth);

    const handleWindowSizeChange = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 640;

  return {isMobile, width};
};
